<template>
    <div>
        <h1 style="font-size: 24px; color: black;">商品数据</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="120px">
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label="商品名称：">
                    <el-input v-model="queryData.name" style="width: 110px" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品类型：">
                    <el-select v-model="queryData.type">
                        <el-option v-for="item in goodType" :key="item.type" :value="item.type" :label="item.val"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" ">
                    <el-button  type="primary" @click="query">查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-table border
                  :data="reportList"
                  ref="filterTable">
            <el-table-column  label="日期"  prop="dt" ></el-table-column>
            <el-table-column  label="平台来源" >
                <template slot-scope="scope">
                    {{scope.row.origin===1 ?'蜂助手':'其他'}}
                </template>
            </el-table-column>
            <el-table-column  label="商品类型" >
                <template slot-scope="scope">
                    <el-row v-if="scope.row.goodsType===0 " >{{'卡券'}}</el-row>
                    <el-row v-if="scope.row.goodsType===1 " >{{'话费'}}</el-row>
                    <el-row v-if="scope.row.goodsType===2 " >{{'实物'}}</el-row>
                </template>
            </el-table-column>
            <el-table-column  label="商品名称" prop="name"></el-table-column>
            <el-table-column  label="单品编码" prop="goodsCode"></el-table-column>
            <el-table-column  label="红包币兑换" prop="coinNumber"></el-table-column>
            <el-table-column  label="当日已消耗金币总量"  prop="sumCoinNumber"></el-table-column>
            <el-table-column  label="当日已消耗" prop="count"></el-table-column>
            <el-table-column  label="当日已消耗人数" prop="userCount"></el-table-column>

        </el-table>
    </div>
</template>

<script>
    import {
        goodsExpand
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "GoodsReport",
        data(){
            return {
                queryData: {
                    type: 0,
                    name:'',
                    timeDate: ['', ''],
                },
                queryTrueData: {
                    goodsType: 0,
                    goodsName:null,
                    startDt: '',
                    endDt: ''
                },
                goodType: [
                    {type:0,val:'卡券'},
                    {type:1,val:'话费'},
                    {type:2,val:'实物'}
                ],
                reportList: [],
                pickerMinDate:'',
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        if (minDate && ! maxDate) {
                            this.pickerMinDate = minDate;
                        }
                        if (maxDate) {
                            this.pickerMinDate = null;
                        }
                    },
                    disabledDate: (time) => {
                        let secondNum = 60 * 60 * 24 * 7 * 1000;
                        if (this.pickerMinDate) {
                            return time.getTime() > this.pickerMinDate.getTime() + secondNum || time.getTime() < this.pickerMinDate.getTime() - secondNum;
                        }
                    }
                },
            }
        },
        methods:{
            query(){
                this.queryTrueData.goodsType = this.queryData.type;
                this.queryTrueData.goodsName= this.queryData.name;
                this.queryTrueData.startDt = this.queryData.timeDate[0];
                this.queryTrueData.endDt = this.queryData.timeDate[1];
                goodsExpand(this.queryTrueData).then(resp => {
                    this.reportList = resp.data.info.list;
                });
            },
            },


        created() {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            this.query();
        },
    }
</script>

<style scoped>

</style>